/**
 * Плашка-факт под аргументом ответа хорара — как в расшифровке недели
 * колеса Любовь/Деньги (components/periods/YearWheel3): значок планеты —
 * значок аспекта — значок планеты, те же глифы, что в натальной карте.
 * Для сигналов без аспекта — одна планета и пометка значком (℞ ретро,
 * ☉ сожжение, номер дома сектором, ⇄ приём, ∅ Луна без курса, ↑/↓ сила в
 * знаке). Слов и терминов нет — только значки.
 *
 * Цвет: зелёный — поддерживает (+), красный — мешает (−), голубой —
 * соединение. Структуру факта отдаёт сервер (horary/answer_blocks.py).
 */

export const ASPECT_SYMBOL = {
  conjunction: '☌', sextile: '⚹', square: '□', trine: '△', opposition: '☍',
};
const MARK_SYMBOL = {
  retro: '℞', combust: '☉', reception: '⇄', void: '∅', dignity_up: '↑', dignity_down: '↓',
};
export const TONE_CLASSES = {
  '+': 'bg-green-50 border-green-200 text-green-800',
  '-': 'bg-red-50 border-red-200 text-red-800',
  conj: 'bg-sky-50 border-sky-200 text-sky-800',
};
// Цвет той же плашки на круге (ПУШ 2) — один источник.
export const TONE_STROKE = { '+': '#16A34A', '-': '#DC2626', conj: '#0284C7' };

export function PlanetIcon({ planet, className = 'h-3.5 w-3.5' }) {
  if (!planet) return null;
  return (
    <img
      src={`/icons/planets/${String(planet).toLowerCase()}.svg`}
      alt=""
      aria-hidden
      className={`${className} shrink-0`}
      loading="lazy"
    />
  );
}

function HouseSector({ house }) {
  if (!house) return null;
  return (
    <span className="inline-flex h-4 min-w-4 items-center justify-center rounded-full border border-current px-1 text-[10px] font-semibold leading-none">
      {house}
    </span>
  );
}

export default function HoraryFact({ fact, active = false, onClick, testId }) {
  if (!fact || !fact.p1) return null;
  const tone = TONE_CLASSES[fact.sign] || TONE_CLASSES.conj;
  const ring = active ? 'ring-2 ring-offset-1 ring-current' : '';
  const Tag = onClick ? 'button' : 'span';
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`mt-1 inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-xs leading-none ${tone} ${ring}`}
      data-testid={testId}
      data-fact-sign={fact.sign}
    >
      <PlanetIcon planet={fact.p1} />
      {fact.aspect ? (
        <>
          <span aria-hidden>{ASPECT_SYMBOL[fact.aspect] || '·'}</span>
          <PlanetIcon planet={fact.p2} />
        </>
      ) : (
        <>
          {fact.mark === 'house' ? <HouseSector house={fact.house} /> : (
            <span aria-hidden className="font-semibold">{MARK_SYMBOL[fact.mark] || ''}</span>
          )}
          {fact.mark === 'reception' && <PlanetIcon planet={fact.p2} />}
        </>
      )}
    </Tag>
  );
}
